import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import BrandBand from './ui/BrandBand';
import HSALogo from './ui/HSALogo';

const Footer = () => {
  return (
    <footer className="bg-black text-white border-t border-white/10">
      {/* Subtle Brand Band */}
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-6 py-8 sm:py-12">
        <div className="text-center space-y-6 sm:space-y-8">
          {/* Brand Mark */}
          <div className="flex justify-center">
            <HSALogo variant="brandmark" size="xlarge" className="opacity-60" />
          </div>
          
          {/* Contact Info - Responsive */}
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-8 lg:space-x-12">
            <a href="tel:+33646599430" className="flex items-center space-x-2 text-white/70 hover:text-[#BFC50D] transition-colors duration-200">
              <Phone className="w-4 h-4" />
              <span className="text-sm font-medium">+33 6 46 59 94 30</span>
            </a>
            <a href="mailto:contact@highselectionauto.com" className="flex items-center space-x-2 text-white/70 hover:text-[#BFC50D] transition-colors duration-200">
              <Mail className="w-4 h-4" />
              <span className="text-sm font-medium">contact@highselectionauto.com</span>
            </a>
            <div className="flex items-center space-x-2 text-white/70">
              <MapPin className="w-4 h-4" />
              <span className="text-sm font-medium">Orléans, France</span>
            </div>
          </div>
          
          {/* Legal Pages - Responsive */}
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-sm">
            <a href="/mentions-legales" className="text-white/60 hover:text-[#BFC50D] transition-colors duration-200">
              Mentions légales
            </a>
            <a href="/politique-confidentialite" className="text-white/60 hover:text-[#BFC50D] transition-colors duration-200">
              Politique de confidentialité
            </a>
            <a href="/cgv" className="text-white/60 hover:text-[#BFC50D] transition-colors duration-200">
              CGV
            </a>
            <a href="/cookies" className="text-white/60 hover:text-[#BFC50D] transition-colors duration-200">
              Cookies
            </a>
          </div>
          
          {/* Copyright */}
          <p className="text-white/50 text-xs font-light">
            &copy; {new Date().getFullYear()} HSA - High Selection Auto. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;